<template>
  <div>
    <div
      class="z-title z-title--small spacer-bottom-l"
      v-if="ready"
    >
      {{ titleOnReady }}
    </div>

    <div
      class="z-title z-title--small spacer-bottom-l"
      v-else
    >
      {{ title }}
    </div>

    <slot></slot>

    <template v-if="ready">
      <div class="z-caption spacer-bottom-s">
        Código do boleto
      </div>

      <div class="payment-code">
        {{ barCode }}
      </div>

      <div class="row">
        <div class="col-md-6">
          <button
            class="z-button z-button--secondary z-button--block spacer-bottom-m js-clipboard-btn"
            v-clipboard:copy="barCode"
            v-clipboard:success="copySuccess"
          >
            Copiar o código do boleto
          </button>
        </div>

        <div class="col-md-6">
          <button
            class="z-button z-button--secondary z-button--block js-download-boleto-btn"
            @click="handleDownloadBoleto()"
          >
            Baixar boleto
          </button>
        </div>
      </div>
    </template>

    <button
      class="z-button z-button--secondary z-button--block spacer-bottom-m js-create-boleto-btn"
      v-else-if="unavailable"
      @click="handleGenerateBoleto()"
    >
      Gerar boleto
    </button>

    <button
      class="z-button z-button--secondary z-button--block spacer-bottom-m"
      v-else-if="waiting"
      disabled
    >
      <z-loading variant="dotsSpinner" size="medium" />
      Gerando boleto
    </button>
  </div>
</template>

<style lang="scss" scoped>

.payment-code {
  color: var(--color-neutral-black);
  font-size: rem(16);
  line-height: rem(24);
  margin-bottom: var(--space-extra-large);
}
</style>

<script>
const stringPropType = { type: String, required: true };
const booleanPropType = { type: Boolean, required: true };
const functionPropType = { type: Function, required: true };

export default {
  props: {
    payment: {
      required: true,
      validator: (payment) => typeof payment === 'object' || payment === null,
    },
    title: stringPropType,
    titleOnReady: stringPropType,
    ready: booleanPropType,
    waiting: booleanPropType,
    unavailable: booleanPropType,
    callbackClipboard: functionPropType,
    handleDownloadBoleto: functionPropType,
    handleGenerateBoleto: functionPropType,
  },
  computed: {
    barCode() {
      return this.payment.bar_code;
    },
  },
  methods: {
    copySuccess() {
      this.$toast.show('success', 'Código copiado', 4000);
      this.callbackClipboard();
    },
  },
};
</script>
